export function hideElement(el, forceHide) {
  if (el.style.display !== 'none') { el.style.display = 'none'; }
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/hideElement.js
// module id = 849
// module chunks = 2